module.exports = __webpack_public_path__ + "img/931-226815.png";